module.exports = __webpack_public_path__ + "img/login-logo.059fbf8b.svg";